import { warehouseService } from '@/services';

export const warehouseModule = {
  namespaced: true,
  state: () => ({
    list: {
      data: null,
      response: null,
      status: 'idle'
    },
    listFilters: {},
    warehouse:{
      data: {
        name: ""
      },
      error: null,
    },
    options: {
      data: null,
      status: 'idle',
      error: null
    }
  }),
  mutations: {
    setListError(state, response) {
      state.list.data = null;
      state.list.response = response;
      state.list.status = 'error';
    },
    setListLoading(state) {
      state.list.data = null;
      state.list.response = null;
      state.list.status = 'loading';
    },
    setListSuccess(state, response) {
      state.list.data = response?.data || null;
      state.list.response = response;
      state.list.status = 'success';
    },
    setListFilters(state, request) {
      state.listFilters = { ...JSON.parse(JSON.stringify(request)) }
    },
    getById(state, idWarehouse) {
      warehouseService.getWarehouseById(idWarehouse)
        .then((res) => {
          state.warehouse.data = { ...res }
        })
        .catch((error) => {
          state.warehouse.data = null
          state.warehouse.error = error
        });
    },
    setOptionsLoading(state) {
      state.options.data = null;
      state.options.status = 'loading';
      state.options.error = null;
    },
    setOptionsSuccess(state, items) {
      state.options.data = items;
      state.options.status = 'success';
    },
    setOptionsError(state, error) {
      state.options.data = null;
      state.options.status = 'error';
      state.options.error = error;
    }
  },
  actions: {
    async getWarehouses({ commit }, request) {
      commit('setListLoading');
      commit('setListFilters', request);
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        const response = await warehouseService.getWarehouses(request.filters, request.pagination, user.customer._id);
        commit('setListSuccess', response);
      } catch (error) {
        commit('setListError', error);
        throw error;
      }
    },
    async getWarehouseStock({ commit }, request) {
      commit('setListLoading');
      commit('setListFilters', request);
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        const response = await warehouseService.getWarehouseStock(request.filters, request.pagination, user.customer._id);
        commit('setListSuccess', response);
      } catch (error) {
        commit('setListError', error);
        throw error;
      }
    },
    async getAllWarehousesV2({ commit }) {
      commit('setOptionsLoading');
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        const response = await warehouseService.getWarehouses({}, {}, user.extraData.customerId);
        const items = response?.data;
        commit('setOptionsSuccess', items || []);
      } catch (error) {
        commit('setOptionsError', error);
        throw error;
      }
    },
    async getAllWarehouses({ commit }) {
      commit('setOptionsLoading');
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        const rows = 100;
        let currentPage = 1;
        let items = [];
        let total = Infinity;
        while (items.length < total) {
          const response = await warehouseService.getWarehouses({}, { currentPage, rows }, user.extraData.customerId);
          const page = response?.data;
          if (!page || !page.items || page.items.length === 0) {
            break;
          }
          items = items.concat(page.items);
          total = page.total;
          currentPage++;
        }
        commit('setOptionsSuccess', items);
      } catch (error) {
        commit('setOptionsError', error);
        throw error;
      }
    }
  }
}